export default __webpack_public_path__ + "static/media/dai.6b6f455e.png";